<template>
    <div class="main">
        <div class="notice">请使用本人的银行卡，并保证银行卡号、身份证、预留手机号一致</div>
        <div class="wrap">
            <div class="pro_box">
                <span class="label">持卡人</span>
                <input type="text"
                       placeholder="请输入持卡人姓名"
                       class="inputStyle"
                       v-model="realName">
            </div>

            <div class="pro_box">
                <span class="label">身份证号</span>
                <input type="text"
                       placeholder="请输入身份证号"
                       class="inputStyle"
                       v-model="idCard">
            </div>

            <div class="pro_box">
                <span class="label">银行卡号</span>
                <input type="text"
                       placeholder="请输入银行卡号"
                       class="inputStyle"
                       v-model="bankCard" @input="inputChange">
            </div>


            <div class="pro_box">
                <span class="label">银行名称</span>
                <input type="text"
                       placeholder="请输入银行名称"
                       class="inputStyle"
                       v-model="bankName">
            </div>


            <div class="pro_box">
                <span class="label">预留手机号</span>
                <input type="text"
                       placeholder="请输入银行绑定的预留手机号"
                       class="inputStyle"
                       v-model="phone">
            </div>
            <div class="inputCode">
                <div class="pro_box" style="border-bottom: none;">
                    <span class="label">验证码</span>
                    <input type="text"
                           placeholder="请输入验证码"
                           class="inputStyle"
                           v-model="code" style="width: 120px;">
                </div>
                <div class="code" @click="ysPaySign">{{codeMsg1}}</div>
            </div>

        </div>
        <div>
            <div class="btn"
                 @click="bindBank">确认
            </div>
            <div class="desc"><span class="content">注：该产品支持绑定  </span><span
                    style="color: #333333;">储蓄卡或借记卡(不支持农业银行、招商银行) ，不支持信用卡，请勿向他人透露验证码，注意保护个人隐私 </span></div>
        </div>

        <van-popup v-model:show="codeToast" :round="true" :closeable="true">
            <div class="codeToast">
                <div class="title">请再次输入验证码</div>
                <div class="center">
                    <input type="text" placeholder="请输入验证码" style="text-indent: 10px;width: 100px;"
                           v-model="confirmCode"/>
                    <div style="line-height: 50px;color: #008AFE;" @click="reachievemsg">{{codeMsg2}}</div>
                </div>

                <div class="btn" @click="resultPay"><span>确认支付</span></div>
            </div>
            <Loading :isShow="loading3"></Loading>
        </van-popup>

        <Loading :isShow="loading1"></Loading>

        <Loading :isShow="loading2"></Loading>

    </div>
</template>

<script>
    import Loading from '@/components/loading';

    export default {
        components: {
            Loading
        },
        name: "bankInfo",
        data() {
            return {
                prepaid: 0,
                realName: "",
                idCard: "",
                bankCard: "",
                bankName: "",
                phone: "",
                code: "",
                codeToast: false,
                confirmCode: "",
                outTradeNo: "",
                protocolNo: "",
                paysn: "",
                scenceCode: 0,
                timer1: null,
                countdown1: 60,
                codeMsg1: "获取验证码",
                timer2: null,
                countdown2: 60,
                codeMsg2: "获取验证码",
                loading1: false,
                loading2: false,
                loading3: false
            }
        }, created() {
            this.util.title("绑定银行卡");
            this.prepaid = this.$route.query.prepaid;
            this.scenceCode = this.$route.query.scenceCode;
            this.getBankInfo();
        }, methods: {
            reachievemsg() {
                if (!this.codeMsg2.includes("获取验证码")) {
                    return;
                }
                if (!this.paysn) {
                    this.util.toast({msg: "交易流水号不能为空"});
                    return;
                }
                let param = {
                    paysn: this.paysn,
                };
                this.$post("/app/v1.0/payBank/ysFastPay/reachievemsg", param)
                    .then((res) => {
                        if (res.code == 200) {
                            this.setTime2();
                            this.util.toast({msg: "短信发送成功"});
                        } else {
                            this.util.toast({msg: res.message});
                        }
                    })
                    .catch((error) => {

                    });

            }, resultPay() {

                if (!this.confirmCode) {
                    this.util.toast({msg: "验证码不能为空"});
                    return;
                }
                let _this = this;
                let param = {
                    paysn: this.paysn,
                    mobileVerifyCode: this.confirmCode
                }
                this.loading3 = true;
                this.$post('/app/v1.0/payBank/ysFastPay/confirm', param)
                    .then(res => {
                        var e = res;
                        if (e.code == 200) {
                            this.loading3 = true;
                            this.$get("/app/v1.0/pay/getReturnUrl?scenceCode=" + this.scenceCode)
                                .then((res) => {
                                    if (res.code == 200) {
                                        this.loading3 = false;
                                        window.location.href = res.data;
                                    } else {
                                        this.loading3 = false;
                                        _this.util.toast({msg: res.message});
                                    }
                                })
                                .catch((error) => {

                                });
                            this.codeToast = false;
                        } else {
                            this.loading3 = false;
                            _this.util.toast({msg: e.message})
                        }
                    })
                    .catch(error => {
                    });
            }, inputChange() {
                if (this.bankCard.trim().length != 6) {
                    return;
                }
                let param = {
                    bankCard: this.bankCard,
                };
                this.$get("/app/v1.0/payBank/getBankName", param)
                    .then((res) => {
                        if (res.code == 200) {
                            this.bankName = res.data;
                        } else {
                            this.util.toast({msg: res.message});
                        }
                    })
                    .catch((error) => {

                    });

            }, bindBank() {
                if (!this.realName) {
                    this.util.toast({msg: "持卡人不能为空"})
                    return;
                }
                if (!this.idCard) {
                    this.util.toast({msg: "身份证号不能为空"})
                    return;
                }
                if (!this.bankCard) {
                    this.util.toast({msg: "银行卡号不能为空"})
                    return;
                }
                /*if (!this.bankName) {
                    this.util.toast({msg: "银行名称不能为空"})
                    return;
                }*/
                if (!this.phone) {
                    this.util.toast({msg: "预留手机号不能为空"})
                    return;
                }
                if (!this.code) {
                    this.util.toast({msg: "验证码不能为空"})
                    return;
                }
                let param = {
                    prepaid: this.prepaid,
                    mobileVerifyCode: this.code,
                    source: 0
                }
                this.loading1 = true;
                this.$post('/app/v1.0/payBank/ysFastPay/sign/confirm', param)
                    .then(res => {
                        var e = res;
                        if (e.code == 200) {
                            this.protocolNo = e.data;
                            this.loading1 = false;
                            let payParam = {
                                prepaid: this.prepaid,
                                memberTypeId: 0,
                                productId: 0
                            }
                            this.loading2 = true;
                            this.$post('/app/v1.0/payBank/ysFastPay', payParam)
                                .then(res => {
                                    var e = res;
                                    if (e.code == 200) {
                                        this.loading2 = false;
                                        this.codeToast = e.data.needSmsConfirm;
                                        if (!this.codeToast) {
                                            this.$router.push({
                                                path: "/afterLoan/newApplySuccess",
                                                query: {
                                                    status: 1
                                                },
                                            });
                                        }
                                        this.paysn = e.data.paysn;
                                        this.closeTime1();
                                        this.closeTime2();
                                        this.setTime2();
                                    } else {
                                        this.loading2 = false;
                                        this.util.toast({msg: e.message})
                                    }
                                })
                                .catch(error => {
                                });
                        } else {
                            this.loading1 = false;
                            this.util.toast({msg: "操作失败，已为您重新发送验证码，请输入新的验证码"})
                            this.closeTime1();
                            this.ysPaySign();
                        }
                    })
                    .catch(error => {

                    });
            }, getBankInfo() {
                this.$get("/app/v1.0/payBank/getBankInfo")
                    .then((res) => {
                        if (res.code == 200) {
                            var data = res.data;
                            this.realName = data.userName;
                            this.idCard = data.idcard;
                            this.bankCard = data.bankCard;
                            this.bankName = data.bankName;
                            this.phone = data.phone;
                        } else {
                            this.util.toast({msg: res.message});
                        }
                    })
                    .catch((error) => {

                    });
            }, ysPaySign() {
                if (!this.codeMsg1.includes("获取验证码")) {
                    return;
                }
                if (!this.realName) {
                    this.util.toast({msg: "持卡人不能为空"})
                    return;
                }
                if (!this.idCard) {
                    this.util.toast({msg: "身份证号不能为空"})
                    return;
                }
                if (!this.bankCard) {
                    this.util.toast({msg: "银行卡号不能为空"})
                    return;
                }
                /*if (!this.bankName) {
                    this.util.toast({msg: "银行名称不能为空"})
                    return;
                }*/
                if (!this.phone) {
                    this.util.toast({msg: "预留手机号不能为空"})
                    return;
                }

                let param = {
                    prepaid: this.prepaid,
                    userName: this.realName,
                    idcard: this.idCard,
                    bankCard: this.bankCard,
                    bankName: this.bankName,
                    phone: this.phone
                }
                this.$post('/app/v1.0/payBank/ysFastPay/sign', param)
                    .then(res => {
                        var e = res;
                        if (e.code == 200) {
                            this.outTradeNo = e.data.outTradeNo;
                            this.prepaid = e.data.prepaid;
                            this.setTime1();
                            this.util.toast({msg: "发送成功"})

                        } else {
                            this.util.toast({msg: e.message})
                        }
                    })
                    .catch(error => {
                    });
            }, setTime1() {//倒计时1
                let _this = this;
                this.timer1 = setInterval(() => {
                    if (_this.countdown1 > 0 && _this.countdown1 <= 60) {
                        _this.countdown1--;
                        if (_this.countdown1 !== 0) {
                            _this.codeMsg1 = "重新发送(" + _this.countdown1 + ")";
                        } else {
                            clearInterval(_this.timer1);
                            _this.codeMsg1 = "获取验证码";
                            _this.countdown1 = 60;
                            _this.timer1 = null;
                        }
                    }
                }, 1000)
            }, closeTime1() {
                clearInterval(this.timer1);
                this.codeMsg1 = "获取验证码";
                this.countdown1 = 60;
                this.timer1 = null;
            }, setTime2() {//倒计时2
                let _this = this;
                this.timer2 = setInterval(() => {
                    if (_this.countdown2 > 0 && _this.countdown2 <= 60) {
                        _this.countdown2--;
                        if (_this.countdown2 !== 0) {
                            _this.codeMsg2 = "重新发送(" + _this.countdown2 + ")";
                        } else {
                            clearInterval(_this.timer2);
                            _this.codeMsg2 = "获取验证码";
                            _this.countdown2 = 60;
                            _this.timer2 = null;
                        }
                    }
                }, 1000)
            }, closeTime2() {
                clearInterval(this.timer2);
                this.codeMsg2 = "获取验证码";
                this.countdown2 = 60;
                this.timer2 = null;
            },


        }
    }
</script>

<style scoped>
    .main {
        background: #F7F7F7;
    }

    .wrap {
        background: #FFFFFF;
    }

    .notice {
        padding: 0.12rem 0 0.1rem 0;
        font-size: 0.12rem;
        color: #5983fc;
        background: #e6ebff;
        text-align: center;
    }

    .pro_box {
        clear: both;
        overflow: hidden;
        border-bottom: 1px solid #eee;
        padding: 0 0.15rem;
        background: #fff;
    }

    .label {
        width: 0.75rem;
        font-family: PingFangSC-Regular, PingFang SC;
        display: inline-block;
        font-size: 0.14rem;
        font-weight: 400;
        color: #333333;
    }

    .inputStyle {
        width: 70%;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333;
        padding: 0.15rem;
    }

    .btn {
        color: #fff;
        background: linear-gradient(
                90deg,
                rgba(122, 157, 246, 1) 0%,
                rgba(81, 117, 241, 1) 100%
        );
        box-shadow: 0rem 0.06rem 0.1rem 0rem rgba(228, 238, 250, 1);
        border-radius: 0.25rem;
        height: 0.5rem;
        line-height: 0.5rem;
        font-size: 0.17rem;
        text-align: center;
        line-height: 0.5rem;
        width: 95%;
        margin: 0 auto;
        margin-top: 0.3rem;
        margin-bottom: 0.1rem;
    }

    .desc {
        padding: 0 0.15rem;
    }

    .desc .content {
        font-size: 0.12rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    input::-webkit-input-placeholder {
        font-size: 0.14rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    .codeToast {
        width: 2.95rem;
        background: #FFFFFF;
        text-align: center;
        padding-bottom: 0.3rem;
    }

    .codeToast .title {
        font-size: 0.2rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #424242;
        letter-spacing: 1px;
        margin-top: 0.49rem;
    }

    .codeToast .center {
        width: 2.59rem;
        height: 0.5rem;
        background: #F5F5F5;
        border-radius: 8px;
        display: flex;
        margin: 0.3rem auto;
        justify-content: space-around;
    }

    .codeToast .btn {
        width: 2.59rem;
        height: 0.5rem;
        background: linear-gradient(132deg, #59A3FC 0%, #3C64F6 100%);
        border-radius: 0.25rem;
        line-height: 0.5rem;
        text-align: center;
        margin: 0.2rem auto;
    }

    .codeToast .btn span {
        font-size: 0.18rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 0.17rem;
    }

    .inputCode {
        display: flex;
        justify-content: space-between;
    }

    .inputCode .code {
        font-size: 0.14rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #527AF5;
        line-height: 50px;
        margin-right: 20px;
    }


</style>
